module.exports = __webpack_public_path__ + "img/02028AM.b090813c.png";